import {PriceModel} from '../Price.model';
import {AdditionalFeeFragment} from '../../../../gql/graphql';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {SPECS} from '../../../../common/constants';

export class AdditionalFeeModel {
  public code: string;
  public name: string;
  public price: PriceModel;

  constructor(params: AdditionalFeeModel) {
    this.code = params.code;
    this.name = params.name;
    this.price = params.price;
  }

  public static fromCheckoutV1(additionalFee: AdditionalFeeFragment, modelContext: ModelContext) {
    return new AdditionalFeeModel({
      code: additionalFee.code!,
      name: mapNullToUndefined(additionalFee.translatedName) ?? additionalFee.name!,
      price: PriceModel.fromCheckoutV1(
        modelContext.flowAPI.experiments.enabled(SPECS.ShowPriceSummaryByTaxIncluded) && modelContext.pricesIncludeTax
          ? additionalFee.price
          : additionalFee.priceBeforeTax,
        modelContext
      ),
    });
  }
}
